import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Promise from "@babel/runtime-corejs3/core-js/promise";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import { computed, defineComponent, ref, toRefs, watch } from "@vue/composition-api";
import ProfileAvatar from "@Shared/components/general/profile-avatar.vue";
import * as AgentGetters from "@Broker/@Modules/agents/store/agent-getters";
import * as AgentActions from "@Broker/@Modules/agents/store/agent-actions";
import * as AccountGetters from "@Broker/@Modules/main/store/account/account-getters";
import * as AccountPlanActions from "@Broker/@Modules/account-plan/store/account-plan-actions";
import * as AccountPlanGetters from "@Broker/@Modules/account-plan/store/account-plan-getters";
import GenericModal from "@Shared/components/modals/generic-modal.vue";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { useAccountStoreGetters } from "@Broker/@Modules/main/store/account/account-helpers";
import { useAccountPlanStoreActions, useAccountPlanStoreGetters } from "../../store/account-plan-helpers";
import { useAgentStoreActions, useAgentStoreGetters } from "@Broker/@Modules/agents/store/agent-helpers";
import Badge from "@Shared/components/general/badge.vue";
import { delay } from "@Shared/@Utils/utils";
import CancelPlanConfirmation from "./modals/cancel-plan-confirmation.vue";
import { reduce } from "lodash";
import { useI18n } from "vue-i18n-composable";
import { showToast } from "@Shared/@Utils/constants";
import Amplitude from "@Shared/@Utils/amplitude";
export default defineComponent({
  name: "ManageSubscriptionsModal",
  components: {
    ProfileAvatar,
    GenericModal,
    SimpleButton,
    Badge,
    CancelPlanConfirmation
  },
  props: {
    mode: {
      validator: prop => {
        var _context;
        return _includesInstanceProperty(_context = ["add", "cancel"]).call(_context, prop);
      },
      default: "add"
    }
  },
  setup(props) {
    const {
      t,
      tc
    } = useI18n();
    const {
      mode
    } = toRefs(props);
    const {
      agents,
      GET_AGENT
    } = useAgentStoreGetters([AgentGetters.AGENTS, AgentGetters.GET_AGENT]);
    const {
      LOAD_AGENTS
    } = useAgentStoreActions([AgentActions.LOAD_AGENTS]);
    const {
      CURRENT_USER_USERNAME
    } = useAccountStoreGetters([AccountGetters.CURRENT_USER_USERNAME]);
    const {
      ADD_SUBSCRIPTIONS,
      CANCEL_SUBSCRIPTIONS,
      LOAD_ACCOUNT_PLAN_DETAILS
    } = useAccountPlanStoreActions([AccountPlanActions.ADD_SUBSCRIPTIONS, AccountPlanActions.CANCEL_SUBSCRIPTIONS, AccountPlanActions.LOAD_ACCOUNT_PLAN_DETAILS]);
    const {
      SUBSCRIPTIONS,
      CURRENT_ACCOUNT_PLAN_INTERVAL
    } = useAccountPlanStoreGetters([AccountPlanGetters.SUBSCRIPTIONS, AccountPlanGetters.CURRENT_ACCOUNT_PLAN_INTERVAL]);
    const selectedAgents = ref([]);
    const manageSubscriptionModal = ref();
    const selectAll = ref();
    const loading = ref(false);
    const loadingSucceeded = ref(true);
    const search = ref("");
    const showCancelModal = ref(false);
    const isAddMode = computed(() => mode.value === "add");
    const filteredAgents = computed(() => {
      const agentsToFilter = isAddMode.value ? agents.value : SUBSCRIPTIONS.value;
      return _filterInstanceProperty(agentsToFilter).call(agentsToFilter, ({
        username,
        isCancellable = true
      }) => {
        var _context2;
        const {
          givenName,
          familyName,
          email
        } = GET_AGENT.value(username);
        const stringToEvaluate = `${givenName} ${familyName} ${email}`;
        const searchValidation = search.value === "" || _includesInstanceProperty(_context2 = stringToEvaluate.toLowerCase()).call(_context2, search.value.toLowerCase());
        return searchValidation && !(username === CURRENT_USER_USERNAME.value || !isCancellable);
      });
    });
    const options = computed(() => {
      const columns = ["selected", "fullName", "email"];
      if (isAddMode.value) columns.push("status");
      const conditionalDisabledClass = [{
        class: "disabled",
        condition: row => row.active || row.isCurrentUser || row.username === CURRENT_USER_USERNAME.value
      }];
      return {
        uniqueKey: "username",
        filterable: false,
        sortable: [],
        columns,
        headings: {
          selected: "",
          fullName: tc("global.doorr.agent", 2),
          email: tc("global.words.email", 1),
          status: t("account.accountPlan.currentPlan")
        },
        orderBy: {
          ascending: true,
          column: "active"
        },
        columnsClasses: {
          selected: "w-10 text-center",
          fullName: "w-30 text-wrap-all",
          email: "w-40 text-wrap-all",
          status: "w-20"
        },
        cellClasses: {
          selected: conditionalDisabledClass,
          fullName: conditionalDisabledClass,
          email: conditionalDisabledClass
        },
        skin: "table table-hover",
        perPage: 999999,
        texts: {
          noResults: t("tables.messages.emptyAgents")
        }
      };
    });
    const allAgentsMarked = computed(() => filteredAgents.value.length === selectedAgents.value.length);
    const areAgentsToSubscribe = computed(() => filteredAgents.value.some(({
      active
    }) => !active));
    const canSubmit = computed(() => selectedAgents.value.length > 0 && areAgentsToSubscribe.value);
    const manageText = computed(() => isAddMode.value ? t("account.accountPlan.subscriptionsTab.addSubscriptions") : tc("account.accountPlan.subscriptionsTab.cancelSubscription", 2));
    const agentsInfo = computed(() => {
      var _selectedAgents$value;
      const numberOfAgents = selectedAgents.value.length - 1;
      const agentName = (_selectedAgents$value = selectedAgents.value[0]) == null ? void 0 : _selectedAgents$value.givenName;
      return {
        agentName,
        numberOfAgents,
        agents: tc("account.accountPlan.planModals.cancelConfirmation.nameAndOtherAgent", numberOfAgents, {
          agentName,
          numberOfAgents
        })
      };
    });
    const handleSelectAllAgents = () => {
      if (!areAgentsToSubscribe.value) return;
      if (allAgentsMarked.value) selectedAgents.value = [];else selectedAgents.value = filteredAgents.value;
    };
    const agentIsSelected = username => selectedAgents.value.some(agent => agent.username === username);
    const handleSelectAgent = agent => {
      var _context3;
      if (agentIsSelected(agent.username)) selectedAgents.value = _filterInstanceProperty(_context3 = selectedAgents.value).call(_context3, ({
        username
      }) => agent.username !== username);else selectedAgents.value.push(agent);
    };
    const openModal = () => {
      var _manageSubscriptionMo;
      (_manageSubscriptionMo = manageSubscriptionModal.value) == null ? void 0 : _manageSubscriptionMo.show();
      Amplitude.logEvent("Account Plan - Manage Subscription Modal Opened", {
        mode: mode.value
      });
    };
    const closeModal = () => {
      var _manageSubscriptionMo2;
      (_manageSubscriptionMo2 = manageSubscriptionModal.value) == null ? void 0 : _manageSubscriptionMo2.hide();
      resetData();
      Amplitude.logEvent("Account Plan - Manage Subscription Modal Closed", {
        mode: mode.value
      });
    };
    const resetData = () => {
      selectedAgents.value = [];
      search.value = "";
    };
    const handleSubmit = async () => {
      if (!(isAddMode.value || showCancelModal.value)) {
        showCancelModal.value = true;
        return;
      }
      loading.value = true;
      const accounts = reduce(selectedAgents.value, (agents, agent) => {
        if (!(agent.active && isAddMode.value)) agents.push(agent.username);
        return agents;
      }, []);
      let result = {
        succeeded: false
      };
      let toastMessageOptions = {
        path: "",
        type: "success"
      };
      let payload = {};
      if (isAddMode.value) {
        payload = {
          accountsToPay: accounts,
          planDuration: CURRENT_ACCOUNT_PLAN_INTERVAL.value === "month" ? "monthly" : "yearly"
        };
        result = await ADD_SUBSCRIPTIONS(payload);
        toastMessageOptions = {
          path: "notification-messages.subscriptionAddedTourDoorrPlan",
          type: "info"
        };
      } else {
        payload = {
          accountsToCancel: accounts
        };
        result = await CANCEL_SUBSCRIPTIONS(payload);
        toastMessageOptions = {
          path: "notification-messages.cancelledYourAgentSubscription",
          type: "success"
        };
      }
      showCancelModal.value = false;
      if (result.succeeded) {
        await delay(8000);
        await _Promise.all([LOAD_ACCOUNT_PLAN_DETAILS(), LOAD_AGENTS()]);
        showToast(toastMessageOptions.type, tc(toastMessageOptions.path, agentsInfo.value.numberOfAgents, agentsInfo.value));
      }
      loadingSucceeded.value = result.succeeded;
      loading.value = false;
      Amplitude.logEvent("Account Plan - Action in Manage Subscriptions Attempt Completed", _objectSpread(_objectSpread({}, payload), {}, {
        result,
        mode: mode.value
      }));
    };
    watch(allAgentsMarked, value => {
      if (selectAll.value) selectAll.value.checked = value;
    });
    return {
      selectAll,
      filteredAgents,
      search,
      options,
      agentsInfo,
      areAgentsToSubscribe,
      allAgentsMarked,
      manageSubscriptionModal,
      CURRENT_USER_USERNAME,
      loading,
      loadingSucceeded,
      canSubmit,
      selectedAgents,
      manageText,
      showCancelModal,
      handleSelectAllAgents,
      agentIsSelected,
      handleSelectAgent,
      openModal,
      closeModal,
      handleSubmit,
      GET_AGENT
    };
  }
});